import { LadyProfileQueryOptions } from "@/features/lady-profile/models";
import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { mapResponse } from "./helpers";
import {
  lastContacts,
  LastContactsResponseDTORaw,
} from "./models/LastContacts.response.dto";
import { SmallLadyResponseDTORaw } from "./models/SmallLadyProfile.dto";

export abstract class SmallLadyProfileApi {
  static getSmallProfile = async (params: LadyProfileQueryOptions) => {
    if (!params.objectId) return null;

    const response = GbApiRequestService.get("userApiV2", {
      params: {
        id: params.objectId,
        requestType: "ladylightdto",
      },
    });

    const validatedData = await withSchemaValidation(
      response,
      SmallLadyResponseDTORaw,
    );

    const mappedResponse = mapResponse(validatedData);
    return mappedResponse.ladyDto;
  };

  static getLastContacts = async () => {
    const response = GbApiRequestService.post("userRpc", null, {
      params: {
        type: JSON.stringify({
          dataMap: {},
          processorClass: "GetLastContacts",
        }),
      },
    });

    const validatedData = await withSchemaValidation(
      Promise.resolve(response),
      LastContactsResponseDTORaw,
    );

    let result = lastContacts(validatedData);

    if (result.success) {
      const mappedResult = result.data.requestDTO.dataMap.result.map(
        (ladyDto) => mapResponse({ ladyDto }).ladyDto,
      );

      return mappedResult;
    } else {
      return undefined;
    }
  };
}
